import { render, staticRenderFns } from "./Cargo.vue?vue&type=template&id=60e89ab8"
import script from "./Cargo.vue?vue&type=script&lang=js"
export * from "./Cargo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports